import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { uploadFile } from "../../../../../utils/uploadToAzure";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { viewPDF } from "../../../../../utils/viewPDF";

const Step1 = ({
  sra,
  setSra,
  setStep,
  fileNames,
  setFileNames,
  storedUser,
}) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [uploading, setUploading] = useState({
    material: false,
  });
  const orgId = JSON.parse(localStorage.getItem("org"));
  const type = JSON.parse(localStorage.getItem("type"));

  const handleChange = (e) => {
    setSra({ ...sra, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = sra || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.title)) {
      newErrors.title = "Title is required";
    }

    if (isEmpty(data.material)) {
      newErrors.material = "Material List is required";
    }
    if (type === "Off" && isEmpty(data.amount)) {
      newErrors.amount = "Write Off Amount is required";
    }

    // Vendor Details
    if (isEmpty(data.details)) {
      newErrors.details = "Inventory Details are required";
    } else if (data.details.length > 250) {
      newErrors.details = "Inventory Details must be up to 250 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    const field = e.target.name;

    if (!file) return;

    const allowedTypes = [
      "application/pdf",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    if (!allowedTypes.includes(file.type)) {
      setErrors({ ...errors, material: "Only PDF or Excel files are allowed" });
      return;
    }

    setUploading({ ...uploading, material: true });

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await uploadFile(
        file,
        orgId,
        "Inventory",
        sra.draftInventoryId,
        storedUser,
      );
      setSra({ ...sra, material: res });
      setFileNames({ ...fileNames, materialFilename: file.name });
      setErrors({ ...errors, material: "" });
    } catch (error) {
      console.log(error);
    } finally {
      setUploading({ ...uploading, material: false });
    }
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/approval/dashboard");
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Write {type} - Inventory</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "20%" }}></span>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">Details</Typography>

        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="title">
              Title <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.title && "input-error"}`}
              type="text"
              name="title"
              id="title"
              onChange={handleChange}
              value={sra?.title || ""}
            />
            {errors.title && <p className="error">{errors.title}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="sapNumber">SAP Document Number</label>
            <input
              className={`${errors.sapNumber && "input-error"}`}
              type="text"
              name="sapNumber"
              id="sapNumber"
              onChange={handleChange}
              value={sra?.sapNumber || ""}
            />
            {errors.sapNumber && <p className="error">{errors.sapNumber}</p>}
          </Grid2>
          {type === "Off" && (
            <Grid2 size={{ xs: 12, sm: 4 }}>
              <label htmlFor="amount">
                Write Off Amount <span style={{ color: "#FF0000" }}>*</span>
              </label>
              <input
                className={`${errors.amount && "input-error"}`}
                type="number"
                name="amount"
                id="amount"
                onChange={handleChange}
                value={sra?.amount || ""}
              />
              {errors.amount && <p className="error">{errors.amount}</p>}
            </Grid2>
          )}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="material">
              Material List <span style={{ color: "#FF0000" }}>*</span>
              <div className={`input-file ${errors.material && "input-error"}`}>
                <input
                  type="file"
                  id="material"
                  name="material"
                  onChange={handleFileUpload}
                />
                <span
                  style={{
                    width: "80%",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {fileNames.materialFilename || "No file chosen"}
                </span>
                <AttachFileIcon
                  fontSize="small"
                  sx={{
                    color: "#555",
                    transform: "rotate(90deg)",
                    "&:hover": { color: "#1A71F6BF" },
                  }}
                />
              </div>
            </label>
            <Box>
              {errors.material && <p className="error">{errors.material}</p>}
              {uploading.material && (
                <span style={{ fontSize: "12px" }}>
                  Uploading File... <CircularProgress size="30px" />
                </span>
              )}
              {sra && sra.material && (
                <Button
                  sx={{
                    margin: "-6% 0 0 0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(sra.material, storedUser)}
                >
                  <Box
                    component="span"
                    sx={{
                      display: "inline-block",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                    }}
                  >
                    {fileNames.materialFilename}
                  </Box>
                </Button>
              )}
            </Box>
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="details">
              Inventory Details <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <textarea
              className={`${errors.details && "input-error"}`}
              type="text"
              name="details"
              id="details"
              onChange={handleChange}
              value={sra?.details || ""}
              rows={4}
            />
            {errors.details && <p className="error">{errors.details}</p>}
          </Grid2>
        </Grid2>
      </div>

      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleUpdate}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step1;
